/** The resume of an Adyen payment after the shopper had to leave the page (see adyen-resume.model). */
export const ADYEN_RESUME_CONSTANTS = {
  /** sessionStorage key, suffixed with the partner id: two widgets of one origin never share it. */
  STORAGE_KEY_PREFIX: 'cw_adyen_resume_',
  /** Drop-in sessions live an hour at Adyen. */
  DROPIN_TTL_MS: 60 * 60 * 1000,
  /** Hosted sessions are minted for 25 minutes. */
  HOSTED_TTL_MS: 25 * 60 * 1000,
  /** Query parameters the widget removes from the page URL on load. */
  URL_PARAMS: {
    REDIRECT_RESULT: 'redirectResult',
    /** Adyen adds it beside redirectResult; only removed together with it. */
    SESSION_ID: 'sessionId',
    /** The Calenso return page's same-tab return from the hosted checkout. */
    HOSTED_NONCE: 'adyen_hosted',
  },
  /**
   * The longest page URL the backend keeps as the hosted return target (`return_to`). A longer one is
   * dropped there, so the hosted page could not send the shopper back to this tab.
   */
  RETURN_TO_MAX_LENGTH: 2048,
  /** First read of a hosted result, and the ceiling the back-off grows to. */
  POLL_INITIAL_MS: 2000,
  POLL_MAX_MS: 10000,
  POLL_BACKOFF_FACTOR: 1.5,
  MESSAGE_KEYS: {
    CONTEXT_CHANGED: 'adyen.errors.context_changed',
    ALREADY_BOOKED: 'adyen.errors.already_booked',
    EXPIRED: 'adyen.errors.expired',
    REFUSED: 'adyen.errors.refused',
    PENDING: 'adyen.errors.pending',
    UNEXPECTED: 'adyen.errors.unexpected',
    RESUME_UNAVAILABLE: 'adyen.errors.resume_unavailable',
  },
} as const;
